const defaultTemplatesAccessContext = {
  'EMS': {
    groups: [
      'ca54afc0-ce18-40e5-9da0-a6588c56ff34',
      'ca54afc0-ce18-40e5-9da0-a6588c56ff34_ADMINS',
      'ca54afc0-ce18-40e5-9da0-a6588c56ff34_INSTRUCTORS',
    ],
    userId: 'auth0|5e985f01a37fbc0c7be8ba3e',
    orgId: 'ca54afc0-ce18-40e5-9da0-a6588c56ff34',
    productType: 'EMS',
  },
  'NURSING': {
    groups: [
      '72b4eeea-14e1-4529-8c76-bf37cbdd555c',
      '72b4eeea-14e1-4529-8c76-bf37cbdd555c_ADMINS',
      '72b4eeea-14e1-4529-8c76-bf37cbdd555c_INSTRUCTORS',
    ],
    userId: 'auth0|5e985f01a37fbc0c7be8ba3e',
    orgId: '72b4eeea-14e1-4529-8c76-bf37cbdd555c',
    productType: 'NURSING',
  },
  'MILITARY': {
    groups: [
      '72542c87-7d2e-4e2c-aee9-2e67296a75f8',
      '72542c87-7d2e-4e2c-aee9-2e67296a75f8_ADMINS',
      '72542c87-7d2e-4e2c-aee9-2e67296a75f8_INSTRUCTORS',
    ],
    userId: 'auth0|5e985f01a37fbc0c7be8ba3e',
    orgId: '72542c87-7d2e-4e2c-aee9-2e67296a75f8',
    productType: 'MILITARY',
  },
};

export default defaultTemplatesAccessContext;